import React from 'react';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import PropTypes from 'prop-types';
import './targetDashboard.scss';
import { EDIT_TARGET, TARGET_DASHBOARD } from '../../Constants/strings';

// target table component for each quarter
const TargetDashboardTable = ({ quarterTargets, quarter }) => {
  const totalQuarterTarget = quarterTargets.reduce(
    (sum, target) => sum + target.currentQuarterTarget,
    0,
  );

  // Function to determine CSS classes based on target details
  const getClassNames = (targetItem) => {
    const totalAchieved = targetItem?.currentQuarterAchieved + targetItem?.currentQuarterOverachieved;
    if (
      totalAchieved === targetItem?.currentQuarterTarget
      && targetItem?.currentQuarterTarget !== 0
    ) {
      return 'Achieved';
    }
    if (totalAchieved > targetItem?.currentQuarterTarget) {
      return 'overAchieved';
    }
    if (targetItem?.currentQuarterPending) {
      return 'pending';
    }
    return '';
  };

  return (
    <div key={quarter} className="quarter-table-card">
      <Typography className="dashboard-quarter-title">
        {EDIT_TARGET.TARGET_QUARTER} {quarter} ({totalQuarterTarget})
      </Typography>
      <TableContainer component={Paper} className="dashboard-target-tables">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{TARGET_DASHBOARD.TARGET_CERTIFICATIONS}</TableCell>
              <TableCell>{TARGET_DASHBOARD.TARGET_SET}</TableCell>
              <TableCell>{TARGET_DASHBOARD.PENDING}</TableCell>
              <TableCell>{TARGET_DASHBOARD.ACHIEVED}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {quarterTargets.map((target) => (
              <TableRow key={target.id}>
                <TableCell>{target.certificationsName}</TableCell>
                <TableCell>{target.currentQuarterTarget}</TableCell>
                <TableCell
                  className={`target-pending ${getClassNames(target)}`}
                >
                  {target.currentQuarterPending}
                </TableCell>
                <TableCell
                  className={`target-over-achieved ${getClassNames(target)}`}
                >
                  {target.currentQuarterAchieved + target.currentQuarterOverachieved}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

TargetDashboardTable.propTypes = {
  quarterTargets: PropTypes.array.isRequired,
  quarter: PropTypes.number.isRequired,
};

export default TargetDashboardTable;
